"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Tabs = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _scrollbar = require("../scrollbar");
var _button = _interopRequireDefault(require("../button"));
var _position = _interopRequireDefault(require("../utilities/position/"));
var _tabsModule = _interopRequireDefault(require("./tabs.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Tabs = exports.Tabs = /*#__PURE__*/function (_Component) {
  function Tabs() {
    var _this;
    _classCallCheck(this, Tabs);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Tabs, [].concat(args));
    _defineProperty(_this, "window", window);
    _defineProperty(_this, "content", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "buttonContainer", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "contentContainer", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "position", new _position["default"]());
    _defineProperty(_this, "state", {
      activeKey: _this.props.defaultActiveKey,
      width: "auto",
      height: _this.props.fixedHeight ? "".concat(_this.props.fixedHeight, "px") : "auto"
    });
    _defineProperty(_this, "setResizeSize", function (callback) {
      clearTimeout(_this.window.resizeTimer);
      /* istanbul ignore next */
      _this.window.resizeTimer = setTimeout(function () {
        callback && callback();
      }, 100);
    });
    _defineProperty(_this, "setSize", function () {
      if (_this.content.current && !_this.isFixedHeight()) {
        var targetBox = _this.position.getNodeBox(_this.content.current);
        _this.setState({
          width: targetBox.width,
          height: targetBox.height
        });
      }
    });
    return _this;
  }
  _inherits(Tabs, _Component);
  return _createClass(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.window.resizeTimer = {};

      /* istanbul ignore else */
      if (!this.isFixedHeight()) {
        this.window.addEventListener("resize", function () {
          _this2.setResizeSize(_this2.setSize);
        });
      }
      new MutationObserver(this.setSize.bind(this)).observe(this.contentContainer.current, {
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      /* istanbul ignore else */
      if (!this.isFixedHeight()) {
        this.window.removeEventListener("resize", this.setResizeSize);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      /* istanbul ignore else */
      if (prevProps.fixedHeight !== this.props.fixedHeight) {
        this.setHeight(this.props.fixedHeight);
      }
    }
  }, {
    key: "setActive",
    value: function setActive(activeKey) {
      if (activeKey !== this.state.activeKey) {
        if (!this.props.canChange || this.props.canChange()) {
          this.props.onChange && this.props.onChange(activeKey);
          this.setState({
            activeKey: activeKey
          });
        }
      }
    }
  }, {
    key: "isFixedHeight",
    value: function isFixedHeight() {
      return this.props.fixedHeight && this.props.fixedHeight > 0;
    }
  }, {
    key: "isFullSize",
    value: function isFullSize() {
      return this.props.fullSize;
    }
  }, {
    key: "getChildrenWidth",
    value: function getChildrenWidth() {
      var children = this.buttonContainer.current.children;
      var totalWidth = 0;
      for (var i = 0; i < children.length; i++) {
        totalWidth += children[i].offsetWidth;
      }
      return totalWidth;
    }
  }, {
    key: "setHeight",
    value: function setHeight(height) {
      this.setState({
        height: "".concat(height, "px")
      });
    }
  }, {
    key: "isActive",
    value: function isActive(eventKey) {
      return this.state.activeKey === eventKey;
    }
  }, {
    key: "getColour",
    value: function getColour(eventKey) {
      if (this.isActive(eventKey)) {
        return "Blue";
      }
      return "LightGrey";
    }
  }, {
    key: "getContentClassName",
    value: function getContentClassName() {
      return "".concat(_tabsModule["default"].content, " ").concat(this.isFixedHeight() ? _tabsModule["default"].fixedHeight : "", " ").concat(this.isFullSize() ? _tabsModule["default"].fullSize : "");
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this3 = this;
      //TODO add icons option to the buttons
      //if in mobile view and icons are available, show the icons with a title tooltip

      return _react["default"].Children.map(this.props.children, function (child) {
        return /*#__PURE__*/_react["default"].createElement(_button["default"], {
          key: "button-".concat(child.props.eventKey),
          colour: _this3.getColour(child.props.eventKey),
          size: "Small",
          disabled: child.props.disabled,
          "data-testid": child.props.eventKey,
          onClick: function onClick() {
            return _this3.setActive(child.props.eventKey);
          }
        }, child.props.title);
      });
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this4 = this;
      return _react["default"].Children.map(this.props.children, function (child) {
        var nodeRef = _this4.isActive(child.props.eventKey) ? _this4.content : /*#__PURE__*/_react["default"].createRef();
        return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
          key: child.props.eventKey,
          nodeRef: nodeRef,
          "in": _this4.isActive(child.props.eventKey),
          timeout: {
            appear: 200,
            enter: 0,
            exit: 0
          },
          onEntered: _this4.setSize,
          appear: true,
          unmountOnExit: true,
          classNames: "transition-tab-fade"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          ref: nodeRef
        }, child));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _tabsModule["default"].tabs,
        "data-testid": "tabs"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _tabsModule["default"].buttons,
        ref: this.buttonContainer
      }, /*#__PURE__*/_react["default"].createElement(_scrollbar.ShadowScrollbars, {
        autoHeight: true,
        trackBackground: true,
        trackPadding: 9
      }, this.renderButtons())), /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getContentClassName(),
        ref: this.contentContainer,
        style: {
          height: this.state.height
        }
      }, this.renderChildren()));
    }
  }]);
}(_react.Component);
Tabs.propTypes = {
  defaultActiveKey: _propTypes["default"].string,
  fixedHeight: _propTypes["default"].number,
  fullSize: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  canChange: _propTypes["default"].func
};
Tabs.defaultProps = {
  defaultActiveKey: "",
  fixedHeight: null,
  fullSize: false
};
var _default = exports["default"] = Tabs;